import { render } from "./SocioNegocioForm.vue?vue&type=template&id=2b985c2a&scoped=true"
import script from "./SocioNegocioForm.vue?vue&type=script&lang=js"
export * from "./SocioNegocioForm.vue?vue&type=script&lang=js"

import "./SocioNegocioForm.vue?vue&type=style&index=0&id=2b985c2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b985c2a"]])

export default __exports__